import moment from 'moment';

const MonitoringHistoryColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 80
  },
  {
    title: 'Domain',
    dataIndex: 'domain',
    width: 150
  },
  {
    title: `Result`,
    dataIndex: 'status',
    slot: 'status',
    sorter: (a, b) => (a.status || '').localeCompare(b.status || ''),
    width: 150
  },
  {
    title: 'Verified On',
    dataIndex: 'verifiedOn',
    slot: 'verifiedOn',
    sorter: (a, b) => moment(a.verifiedOn).diff(moment(b.verifiedOn)),
    width: 200
  },
  {
    title: 'Detail',
    dataIndex: 'detail',
    slot: 'detail',
    width: 250
  }
];

export { MonitoringHistoryColumn };
